import RepaymentOptionsRefinancing from 'tio-employee/components/repayment-options/refinancing';

<template><RepaymentOptionsRefinancing class="scroll-smooth" /></template>
